// ContraindicationsDialog.jsx (mobile-friendly)
import * as React from 'react';
import {
  Dialog,
  DialogContent,
  DialogBody,
  DialogFooter,
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';

export default function ExpressCareDialog({ open, onOpenChange, onProceed }) {
  const handleSelect = (type) => {
    onOpenChange?.(false);
    onProceed?.(type);
  };

  const cases = [
    {
      id: 1,
      title: 'Viršutinių galūnių sužalojimai',
      items: [
        'Kas yra viršutinių galūnių sužalojimai?',
        'Kai sužalojamas petys, kaklas, žastas, alkūnė, riešas, nykštys ir pirštai.',
        'Kokiais atvejais galima kreiptis į Express Care®?',
        'Uždari lūžiai, išnirimai, patempimai, patinimai, sąnarių ir raumenų skausmas, kiti minkštųjų audinių pažeidimai.',
      ],
    },
    {
      id: 2,
      title: 'Apatinių galūnių sužalojimai',
      items: [
        'Kas yra apatinių galūnių sužalojimai?',
        'Kai trauma apima blauzdos, kelio, kulkšnies, pėdos ar pirštų sritis.',
        'Į apatinių galūnių sužalojimus įeina ir raumenų patempimai, lūžiai ir pėdų skausmai.',
        'Kokiais atvejais galima kreiptis į Express Care®?',
        'Uždari lūžiai, išnirimai, patempimai, patinimas, minkštųjų audinių pažeidimai, sąnarių ir raumenų skausmas',
      ],
    },
    {
      id: 3,
      title: 'Žaizdos ir jų priežiūra',
      items: [
        'Teikiama pagalba iškart po sužeidimo (nubrozdinimai, įpjovimai, įtrūkimai) ir žaizdų priežiūra.',
        'Klinikoje atliekamas žaizdų valymas, susiuvimas, perrišimas. Taip pat galima kreiptis, jei įtariate infekciją.',
      ],
    },
    {
      id: 4,
      title: 'Lengvi galvos sužalojimai',
      items: [
        'Į Express Care® galima kreiptis patyrus veido, ausų ar nosies traumas.',
        'Priimami tik sąmoningi pacientai, kurie po galvos traumos nepatyrė sąmonės praradimo, amnezijos, vėmimo ar galūnių silpnumo ir kurių judrumas nepasikeitė.',
      ],
    },
    {
      id: 5,
      title: 'Kiti atvejai',
      items: [
        'Nedideli nudegimai',
        'Gyvūnų ir vabzdžių įkandimai',
        'Svetimkūnių pašalinimas iš ausų ir nosies',
        'Infekcija',
        'Bėrimas ar odos infekcijos',
        'Gerklės skausmas',
        'Akių ir ausų problemos',
        'Lengvos alerginės reakcijos',
        'Dažnas ir skausmingas šlapinimasis (moterims)',
        'Nestiprus kraujavimas iš nosies',
        'Nestiprūs galvos skausmai',
        'Netrauminės kilmės nugaros skausmai',
        'Bėrimai',
        'Karščiavimas',
        'Dehidratacija, skysčių trūkumas',
        'Viršutinių kvėpavimo takų infekcijos (kosulys, karščiavimas, gerklės skausmas)',
        'Akių problemos, kai nėra regos sutrikimo (pūliavimas, niežulys, miežis)',
      ],
    },
  ];

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-3xl mt-6 sm:mt-0 max-h-[85vh]">
        <DialogBody className="space-y-6 max-h-[65vh] overflow-y-auto">
          <h3 className="text-lg font-semibold">
            Pasirinkite dėl kokių nusiskundimų registruojatės
          </h3>

          <div className="space-y-4">
            {cases.map(({ id, title, items }) => (
              <div key={id} className="space-y-2">
                <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2">
                  <strong className="text-sm sm:text-base">{title}</strong>
                  <Button
                    onClick={() => handleSelect(id)}
                    className="w-full sm:w-auto"
                  >
                    Tęsti
                  </Button>
                </div>
                <ul className="list-disc ml-4 text-sm space-y-1">
                  {items.map((item, idx) => (
                    <li key={idx}>{item}</li>
                  ))}
                </ul>
                <hr className="border-t border-muted/30 mt-2" />
              </div>
            ))}
          </div>
        </DialogBody>

        <DialogFooter>
          <Button variant="light" onClick={() => onOpenChange(false)}>
            Atšaukti
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
